import { Filter } from '@fabric-ui/components';
import { Source } from '../../../hooks/useGetSourcesList';
import {
  compareFieldname,
  filterToSqlConverter,
  isStringConditionExpr,
  iterateFilter,
  mergeAnd,
  SqlToFilterConverter,
  type SqlToFilterConverterColumnSchema,
} from '../../../utils/filter';

const createStatement = (table: string, where: string) => `SELECT * FROM "${table}" WHERE ${where}`;
export const createParser = (columnRef: SqlToFilterConverterColumnSchema) => SqlToFilterConverter.create(columnRef);
export const extractWhereStatement = (sql: string) => sql.split('WHERE')[1]?.trim() || '';
export const DEFAULT_LOGS_TABLE_NAME = 'LOGS';

export const tryParse = (parser: ReturnType<typeof createParser>, table: string, sql: string) => {
  if (sql && table) {
    try {
      const statement = createStatement(table, sql);
      return parser.parse(statement);
    } catch {
      /* empty */
    }
  }
  return null;
};

export const getSelectedSourceFromFilter = (filter: Filter, sources: Source[]) =>
  Array.from(iterateFilter(filter)).reduce((acc, node) => {
    if (isStringConditionExpr(node) && compareFieldname(node, 'source')) {
      const sourceName = node.expression.stringCondition.equals;
      if (sourceName) {
        const source = sources.find(s => s.mappedSourceName === sourceName || (s.isFirstParty && s.name === sourceName));
        if (source) {
          acc.push(source);
        }
      }
    }
    return acc;
  }, [] as Source[]);

export const getSourceByTable = (table: string, sources: Source[] = []) => {
  const source = sources.find(source => source.projectionIdName === table);
  return source ? [source] : [];
};

export const initialState = () => ({
  table: DEFAULT_LOGS_TABLE_NAME,
  query: '',
});

export function filterToWhereSql(newFilter: Filter, table: string) {
  const ensuredFilter = mergeAnd(newFilter);
  const query = filterToSqlConverter(ensuredFilter, table);
  const where = extractWhereStatement(query);
  return where;
}
